import { jsx as o } from "react/jsx-runtime";
import { components as i } from "react-select";
import { RemoveButtonContainer as t, StyledCloseIcon as l } from "./styles.js";
import { Tooltip as m } from "../Tooltip/Tooltip.js";
const c = ({ ...e }) => e.selectProps.isDisabled ? null : /* @__PURE__ */ o(m, { tooltip: "Remove", delay: 300, positioning: "fixed", children: /* @__PURE__ */ o(t, { children: /* @__PURE__ */ o(i.MultiValueRemove, { ...e, children: /* @__PURE__ */ o(l, {}) }) }) });
export {
  c as MultiValueRemove
};
//# sourceMappingURL=MultiValueRemove.js.map
